import type { ListElements } from '@/typings/customilyElements/layer';
import { ListElementType } from '@/typings/customilyElements/listElementType';

export const getEpsId = (treeItem: ListElements): number | null => {
    if (treeItem.type === ListElementType.PageEps) {
        return treeItem.element.id;
    } else {
        return treeItem.element.pageEpsId;
    }
};

export const updateItemElement = (items: ListElements[], parent?: ListElements) => {
    for (const item of items) {
        item.parent = parent;
        if (parent) {
            const isParentEps = parent.type === ListElementType.PageEps;
            switch (item.type) {
                case ListElementType.Group: {
                    item.element.pageEpsId = isParentEps ? parent.element.id : parent.element.pageEpsId;
                    item.element.parentId = isParentEps ? null : parent.element.id;
                    break;
                }
                case ListElementType.CanvasElement:
                    item.element.set({
                        pageEpsId: isParentEps ? parent.element.id : parent.element.pageEpsId,
                        groupId: isParentEps ? null : parent.element.id
                    });
                    break;
                case ListElementType.PageEps:
                    // No need to update
                    break;
            }
        } else {
            switch (item.type) {
                case ListElementType.Group:
                    item.element.pageEpsId = null;
                    item.element.parentId = null;
                    break;
                case ListElementType.CanvasElement:
                    item.element.set({
                        pageEpsId: null,
                        groupId: null
                    });
                    break;
                case ListElementType.PageEps:
                    // No need to update
                    break;
            }
        }

        if (item.children && item.children.length) {
            updateItemElement(item.children, item);
        }
    }
};

export const findTreeItemByIds = (items: ListElements[], ids: string[]): ListElements[] => {
    const foundElements: ListElements[] = [];

    const findElements = (items: ListElements[]) => {
        for (const item of items) {
            if (
                (item.element?.uuid && ids.includes(item.element.uuid)) ||
                (!item.element?.uuid && item.element?.id && ids.includes(item.element.id))
            ) {
                foundElements.push(item);
            }

            if (item.children && item.children.length > 0) {
                findElements(item.children);
            }
        }
    };

    findElements(items);
    return foundElements;
};

export const getUniqueEpsIds = (elements: ListElements[]): number[] => {
    const epsIds = elements.map(getEpsId).filter((id): id is number => id !== null);
    return [...new Set(epsIds)];
};
